import script from "./collect.vue?vue&type=script&setup=true&lang=js"
export * from "./collect.vue?vue&type=script&setup=true&lang=js"

import "./collect.vue?vue&type=style&index=0&id=46a28e43&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a28e43"]])

export default __exports__